import React from 'react';
import './NotasVersion.css';


export const NOTAS_ACTUALIZACIONES = [
  {
    version: '1.0.12',
    fecha: '2026-10-30',
    titulo: 'Fix',
    items: [
      'Se agrega columna seguimiento en tareas.',
    ],
  },
  {
    version: '1.0.12',
    fecha: '2026-10-28',
    titulo: 'Fix',
    items: [
      'Se ajustas modfidicaciones de correcciones de tareas.',
      'Ajustes visuales en correcciones de tareas.',
    ],
  },
  {
    version: '1.0.12',
    fecha: '2026-10-24',
    titulo: 'Fix',
    items: [
      'Se agrega previasualización de tareas (para docentes).',
      'Se agrega previasualización de clases (para docentes).',
      'Se agregan mas notificaciones.',
      'Fix grupos.',
      'Se actualiza la modficacion de tareas corregidas.',
    ],
  },
  {
    version: '1.0.12',
    fecha: '2026-10-19',
    titulo: 'Fix',
    items: [
      'Fix reentregas.',
      'Fix editar devolucion en entregas.',
      'Notificacion reentrega para docente.',
    ],
  },
  {
    version: '1.0.12',
    fecha: '2026-10-18',
    titulo: 'Fix',
    items: [
      'Fix estado en correcciones.',
      'Fix actualizacion correcciones de tareas.',
      'Ajustes en grupos.',
    ],
  },
  {
    version: '1.0.12',
    fecha: '2026-10-11',
    titulo: 'Fix',
    items: [
      'Se agrega poder ver miembros del grupo en la sección de tareas.',
    ],
  },
  {
    version: '1.0.12',
    fecha: '2026-10-11',
    titulo: 'Update',
    items: [
      'Se agrega la posibilidad de habilitar tarea para un estudiante específico.',
      'Se agrega la posibilidad de que los estudiantes dejen comentarios en las devoluciones.',
      'Se agrega la posibilidad de que los profesores puedan dejar comentarios en las tareas luego de corregidas.',
      'Se agrega sistema de notificaciones.',
    ],
  },
  {
    version: '1.0.11',
    fecha: '2026-10-10',
    titulo: 'Fix',
    items: [
      'Ajustes visuales.',
    ],
  },
  {
    version: '1.0.11',
    fecha: '2026-10-03',
    titulo: 'Fix',
    items: [
      'Se arregla comportamiento en la pestaña de Pendientes en el modulo de correcciones.',
      'Se ajusta visual de la tabla del mapa de calor.',
      'Se agregan asistencias a estadisticas.',
      'Se arregla un problema de concurrencia en la correcion de tareas',
    ],
  },
  {
    version: '1.0.11',
    fecha: '2026-09-27',
    titulo: 'Update',
    items: [
      'Ajustes en grupos.',
      'Mejora UX de grupos.',
      'Se agrega la posibilidad de editar una entrega de tarea.',
    ],
  },
  {
    version: '1.0.10',
    fecha: '2026-09-22',
    titulo: 'Fix',
    items: [
      'Publicación tareas.',
      'Lenguaje entrega',
    ],
  },
  {
    version: '1.0.10',
    fecha: '2026-09-19',
    titulo: 'Fix',
    items: [
      'Ajustes en mis cursos.',
      'Ajustes en clases.',
      'Ajustes en msg errores.',
      'Se arregla descarga material de tarea.',
    ],
  },
  {
    version: '1.0.10',
    fecha: '2026-09-15',
    titulo: 'Fix',
    items: [
      'Ajustes en duración horas de clase.',
    ],
  },
  {
    version: '1.0.10',
    fecha: '2026-09-13',
    titulo: 'Update',
    items: [
      'Ajustes de fecha en mis cursos.',
      'Ajustes visuales modal cursos.',
      'Ajustes en asistencias, se pone un total y un filtro.',
      'Se agrega exportacion de asistencias.',
      'Se agregan plantillas de certificados.',
      'Se agrega un btn para fijar la sidebar.',
      'Se normalizan varios datos en la base de datos.',
    ],
  },
  {
    version: '1.0.9',
    fecha: '2026-08-31',
    titulo: 'Update ( funcionalidad no mejora)',
    items: [
      'Se mejora la creacion de tareas permitiendo seleccionar la extension en la subida de Scripts.',
    ],
  },
  {
    version: '1.0.9',
    fecha: '2026-08-28',
    titulo: 'Fix',
    items: [
      'ajustes en seccion de estudiantes.',
    ],
  },
  {
    version: '1.0.9',
    fecha: '2026-08-21',
    titulo: 'Fix + Update',
    items: [
      'ajustes en seccion de mis grupos.',
      'se crea material compartido entre cursos',
    ],
  },
  {
    version: '1.0.8',
    fecha: '2026-07-06',
    titulo: 'Fix',
    items: [
      'ajustes en tareas grupales.',
      'ajuste en estudiantes',
      'ajuste en correcciones de tareas',
      'ajuste calculo entrega en tareas',
      'ajuste de estado en tareas',
    ],
  },
  {
    version: '1.0.8',
    fecha: '2026-06-17',
    titulo: 'Update',
    items: [
      'se agrega tema oscuro para la interfaz',
      'se agrega subir archivos al crear tarea',
      'se rediseño mi asistencia',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-06-14',
    titulo: 'Fix',
    items: [
      'ajustes ordenamiento de tareas pendientes de correccion',
      'ajustes de paginacion en Calificaciones',
      'ajustes resumen estudiantes',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-05-31',
    titulo: 'Fix',
    items: [
      'Ajustes de archivos en nueva tarea',
      'Ajsuste visual en calendario',
      'Ajustes Dashboard - Estudiantes',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-05-21',
    titulo: 'Fix',
    items: [
      'Ajustes en comportamiento cursos disponibles',
      'Ajustes visuales en ver corrección',
      'Ajustes visuales en corrección tarea',
      'Ajustes visuales en entrega tarea',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-05-19',
    titulo: 'Fix',
    items: [
      'Ajustes en ver corrección',
      'Ajustes en mis cursos',
      'Ajustes Home',
      'Ajustes Calificaciones',
      'Ajustes Tareas por Grupo',
      'Ajustes en seguridad',
      'Ajustes visuales en Dashboard, Navbar, Sidebar, Gestion de Tareas',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-05-15',
    titulo: 'Fix',
    items: [
      'Ajustes en mi perfil',
      'Ajustes en edición de perfil',
      'Ajustes modificación contraseña',
      'Ajustes edición plantillas email',
      'Ajustes en estregas de tarea',
      'Fix paginación correccion tareas',
      'Ajuste vista de calificaciones',
      'Fix entregas',
      'Fix visual calendario',
      'Ajuste modal tarea en mis cursos',
      'Ajuste documentación',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-04-28',
    titulo: 'Fix',
    items: [
      'Ajustes en calificaciones, se arregla que se pueda ver la devolución',
      'Se ajusta orden de las tareas en Gestion de Tareas (Pendientes/Corregidas)',
      'Se ajsuta visual de la fecha en el calendario del lado de los alumnos'
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-03-19',
    titulo: 'Fix',
    items: [
      'Se ajusta fecha en Gestion de Cursos',
      'Se ajusta time-out en carga masiva de usuarios',
      'Ajuste en modales',
      'Ajuste visual en Gestion de Cursos - Columna Equipo',
      'Ajuste visual en Gestion de Usuarios - Columna Roles',
      'Ajuste seguridad panel admin',
      'Ajuste visual en mis cursos',
      'Se agrega input para enlace a meet/zoom',
      'Ajsutes visuales en cursos disponibles y dashboard',
    ],
  },
  {
    version: '1.0.7',
    fecha: '2026-03-18',
    titulo: 'Update + Fix',
    items: [
      'Se implementa la Lista Negra de usuarios.',
      'Se agrega bloqueo de registro',
      'Ajustes carga masiva de usuarios',
      'Se agrega fecha a los msg del chat',
    ],
  },
  {
    version: '1.0.6',
    fecha: '2026-03-15',
    titulo: 'Update + Fix',
    items: [
      'Se ajusta horario msg en el chat.',
      'Se agrega cache con REDIS',
      'Ajustes configuracion en general',
      'Ajuste en msg de pre-inscripcion',
      'Se crea sistema de notificaciones',
      'Configuraciom de notificaciones para estudiantes',
      'Ajustes visuales',
    ],
  },
  {
    version: '1.0.5',
    fecha: '2026-03-09',
    titulo: 'Update',
    items: [
      'Se agrega modulo Chat y se implementa funcionamiento.',
      'Se modifican la creacion/edicion de cursos agregando el Nivel',
      'Se agregan badges para los niveles de los cursos.',
      'Se agregan nuevos graficos a estadisticas',
      'Se hacen ajustes en creacion/edicion de cursos',
      'Se agrega generacion de informes',
      'Se agrega pre-view a creacion/edicion de clases y tareas',
      'Modificacion en la visualizacion de las clases y tareas',
      'Descarga de codigo en clases y tareas',
      'Se implementa sistema de grupos para entrega de tareas',
      'Ajustes en carga masiva de usuarios',
      'Ajuste registro no se permite mismo DNI/mail',
      'Ajustes campo telefono',
      'Normalizacion telefono: se quita .0 de Excel y solo se aceptan digitos',
      'Nombre/apellido: se guardan en minuscula y se muestran en Title Case',
      'Pais/provincia/partido/barrio: misma normalizacion (minuscula + Title Case)',
      'Habilidades (incl. Otras): misma normalizacion al guardar y mostrar',
      'DNI numerico se muestra con puntos (35.136.461); se guarda sin puntos',
    ],
  },
  {
    version: '1.0.4',
    fecha: '2026-03-01',
    titulo: 'Update + Fix',
    items: [
      'Correción error modulo asistencias.',
      'Se agrega modulo de reuniones.',
      'Modificaciones visuales en el Dashboard.',
      'Modificacion form de regisro, mi perfil , completar perfil',
      'Se hacen ajustes en la entrega de tareas',
      'Se modifica la forma de inscripcion, se agrega pre-inscripcion',
      'Se agrega modulo de pre-inscripciones',
      'Ajustes en cursos, se permite reutilizar informacion de cursos anteriores.',
      'Ajustes en el mostrado de cursos en la home',
    ],
  },
  {
    version: '1.0.3',
    fecha: '2026-02-22',
    titulo: 'Update',
    items: [
      'Se configuran rutas para subida de archivos.',
      'Se aplica la logica del form de inscripcion en completar perfil de estudiante.',
      'Los usuarios ahora pueden agregar foto de perfil.',
      'Habilitada la opcion para darse de baja de un curso',
      'Se reestrutura, creacion/edicion de cursos, clases y tareas.',
      'Se agrega bbcode para formato de texto.',
      'Ajustes a crear/editar clases, agregando soporte para los diferentes tipos de materiales.',
      'Se modifica la forma de visualizar las clases/tareas agregando un modal.',
      'Se agrega entrega de tareas',
      'Se agrega correcion de tareas',
      'Se crea modulo calificaciones',
      'Moficicaciones en el modulo de asistencias',
    ],
  },
  {
    version: '1.0.2',
    fecha: '2026-02-14',
    titulo: 'Update + Fix',
    items: [
      'Se agrega accion de aprobar estudiantes en el perfil de profesor.',
      'Se agrega favicon al sitio.',
      'Se modifica mi perfil -> mis cursos, ahora muestra los cursos en los que se esta inscripto.',
      'Se agrega generacion de certificados (modo testeo).',
      'Se actualiza el form de registro, agregando en la alerta los campos que faltan y destancandolos con color rojo.',
      'Se modifica el form de registro, agregar input al seleccionar "otros" en habilidades.',
      'Se modifica mi perfil -> estudio y trabajo, siguiendo la misma logica del form de registro.',
      'Se hacen ajustes en el modo de guardado de datos en mi perfil.',
      'Se ajustan restricciones a rutas.',
      'Se ajusta visual de la fecha de nacimiento en el perfil.',
      'Se agrega respuesta 404 en caso de que no se encuentre la pagina.',
      'Se agrega respuesta en construccion en caso de secciones no terminadas.',
      'Se modifica el cupo maximo de cursos, al poner un 0 es sin limite.',
      'Se modifica el enlace de la home de "incribirme" ahora lleva a cursos disponibles. (si se esta logueado)',
      'Ajustes visuales para diferentes paginas.',
      'Se corrige bug en el calendario de reuniones, clases y tareas.',
    ],
  },
  {
    version: '1.0.1',
    fecha: '2026-02-11',
    titulo: 'Primer Update',
    items: [
      'Se agregan notas de la versión en el Dashboard.',
      'Se agrega edición de perfil por secciones con opción de cambiar contraseña.',
      'Se modifica el enlace de mis cursos del perfil, ahora ya no lleva a gestiion de cursos.',
      'Se agrega cambio de estado en los input contraseña.',
      'Se agrega contenedor con cerbot para ssl.',
      'Se agrega calendario de reuniones, clases y tareas con fechas y horarios.',
      'Se modifica el nombre de usuario en el Dashboard.',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-02-10',
    titulo: 'Lanzamiento Online',
    items: [
      'Se despliega el campus virtual online.',
      'Sistema Multi-rol: Coordinador, Profesor, Tutor , Pasante, Ayudante, Estudiante.',
      'Creacion de usuario y login.',
      'Gestion de Usuarios, cursos, clases, tareas.',
      'Sistema de asistencia, reportes.',
    ],
  },
];


const formatFecha = (fechaStr) => {
  if (!fechaStr) return '';
  const [y, m, day] = String(fechaStr).split(/[-/]/).map(Number);
  if (!y || !m || !day) return fechaStr;
  const d = new Date(y, m - 1, day);
  return d.toLocaleDateString('es-AR', { year: 'numeric', month: 'long', day: 'numeric' });
};

const NotasVersion = () => {
  return (
    <div className="notas-version">
      <div className="notas-version-header">
        <h1>Notas de la versión</h1>
        <p>Actualizaciones y mejoras del Campus Virtual</p>
      </div>

      <div className="notas-version-list">
        {NOTAS_ACTUALIZACIONES.length === 0 ? (
          <p className="notas-version-empty">Aún no hay notas publicadas.</p>
        ) : (
          NOTAS_ACTUALIZACIONES.map((nota, index) => (
            <article key={index} className="notas-version-card">
              <div className="notas-version-card-header">
                <span className="notas-version-badge">v{nota.version}</span>
                {nota.fecha && (
                  <time className="notas-version-fecha" dateTime={nota.fecha}>
                    {formatFecha(nota.fecha)}
                  </time>
                )}
              </div>
              {nota.titulo && <h2 className="notas-version-titulo">{nota.titulo}</h2>}
              <ul className="notas-version-items">
                {nota.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </article>
          ))
        )}
      </div>
    </div>
  );
};

export default NotasVersion;
